module.exports = __webpack_public_path__ + "img/pro_one.7d0850ad.jpg";